module.exports = __webpack_public_path__ + "static/media/profile_phone.cb5e8ece.svg";